/**
 * Predicate to identify inputs that can have focus() called on them
 */
const isFocusableInput = el => !!(el && typeof el.focus === 'function')

export default isFocusableInput
